import React from 'react';

const Fire = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4653 7.7945C13.2751 5.7037 13.3983 3.11111 13.3983 3.11111C13.3983 2.50179 12.8933 2 12.2528 2C11.9325 2 11.6492 2.13142 11.4399 2.33453C10.1835 3.51732 9.28435 4.87933 8.70544 5.9307C7.6708 8.00956 7.95409 9.86141 8.21275 10.7814C8.32361 11.1876 8.11422 11.1637 7.97873 11.1159C7.21506 10.6141 6.8086 9.96894 6.62384 9.47909C6.50067 9.15651 6.04493 9.09677 5.81091 9.37157C4.38211 11.0323 3.68004 13.3023 4.14809 15.7276C4.73931 18.7742 7.26433 21.2473 10.4052 21.8447C15.5292 22.8124 20.0003 19.0251 20.0003 14.2342C20.0003 11.546 18.5961 9.19235 16.4653 7.7945Z"
        fill="url(#paint0_linear_6516_452)"
      />
      <path
        d="M14.9254 16.4684C14.9254 16.4684 14.9254 16.4086 14.9254 16.3847C14.9254 15.1422 13.903 13.589 13.903 13.589C13.2625 12.5735 12.5358 11.9522 12.0924 11.6416C11.9569 11.546 11.7598 11.6655 11.7845 11.8327C11.9323 12.5854 11.7106 13.0872 11.4765 13.3859C11.2179 13.7204 10.7745 13.8997 10.7745 13.8997C9.55507 14.4492 8.76677 15.7635 9.16092 17.221C9.41958 18.1768 10.2202 18.9534 11.2056 19.2043C13.1394 19.6942 14.8761 18.3202 14.9254 16.54C14.9254 16.54 14.9254 16.5042 14.9254 16.4803C14.9254 16.4803 14.9254 16.4564 14.9254 16.4445V16.4684Z"
        fill="#FFC0C2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6516_452"
          x1="11.9941"
          y1="2"
          x2="11.9941"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF696F" />
          <stop offset="1" stopColor="#FF2539" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Fire;
